// TODO
// Everything here is deprecated
// Plan to refactor it
import { Injectable } from '@angular/core';
import { Tool } from '@app/shared/utils';
import { GTMService } from './gtm.service';

@Injectable({ providedIn: 'root' })
export class GtmEventsService {
  constructor(private _gtmService: GTMService) {}

  /**
   * Login
   */
  sendLoginPageView(): void {
    this._gtmService.deprecatedSendPageView({ type: 'Login', virtualPageUrl: '/login' });
  }

  /** Home Page **/
  sendHomePageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Homepage',
      virtualPageUrl: '/home',
    });
  }

  /** Account Page **/
  sendAccountPageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Account',
      module: 'Account',
      virtualPageUrl: '/account',
    });
  }

  /** Product Catalog Page */
  sendProductCatalogPageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Product Catalog',
      module: 'Product Catalog',
      virtualPageUrl: '/products',
    });
  }

  /** Pet record */
  sendPetRecordPageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Listing',
      module: 'Pets & Pet Owner',
      virtualPageUrl: '/directory',
    });
  }

  /** FAQ **/
  sendFAQPageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'FAQs',
      module: 'Help',
      virtualPageUrl: '/support',
    });
  }

  /** Contact Popin */
  sendPopinResult(formName: string, formType: string, success: boolean): void {
    this._gtmService.deprecatedSendEvent({
      name: formName,
      interaction: {
        category: formType,
        action: 'Form submit',
        label: success ? 'Success' : 'Error',
      },
    });
  }

  /** Create patient Popin */
  sendCreatePatientPopinView(tool: Tool): void {
    switch (tool) {
      case Tool.Rationing:
        this._gtmService.deprecatedSendPageView({
          type: 'Nutritional Recommendation',
          module: 'Daily Allowance',
          moduleType: 'Consultation',
          virtualPageUrlPopin: '/daily-allowance/recommendation/create-patient',
        });
        break;
      case Tool.WeightManagement:
        this._gtmService.deprecatedSendPageView({
          type: 'Nutritional Recommendation',
          module: 'Weight Management',
          moduleType: 'Consultation',
          virtualPageUrlPopin: '/weight-management/recommendation/create-patient',
        });
        break;
      case Tool.SmartReco:
        this._gtmService.deprecatedSendPageView({
          type: 'Nutritional Recommendation',
          module: 'Smart Recommendation',
          moduleType: 'Consultation',
          virtualPageUrlPopin: '/smart-recommendation/recommendation/create-patient',
        });
        break;
      case Tool.RenalDetect:
        this._gtmService.deprecatedSendPageView({
          type: 'Nutritional Recommendation',
          module: 'Renal Detect',
          moduleType: 'Consultation',
          virtualPageUrlPopin: '/renal-detect/recommendation/create-patient',
        });
        break;
    }
  }

  /*************
   * PET OWNER PAGE
   **************/
  sendPetOwnerProfileView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Owner Profile',
      module: 'Pets & Pet Owner',
      virtualPageUrl: '/pet-owner/profile',
    });
  }

  /**************
   * PET PAGE
   *************/

  /**
   * Profile
   */
  sendPetPageProfileView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Profile',
      module: 'Pets & Pet Owner',
      virtualPageUrl: '/pet/profile',
    });
  }

  /**
   * Health Tracking
   */
  sendHealthTrackingPageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Health Tracking',
      module: 'Pets & Pet Owner',
      virtualPageUrl: '/pet/health-tracking',
    });
  }

  /**
   * Send different page view event on GTM
   * 1 - Sent page view when it's a first visit
   * 2 - Sent page view when it's a follow up
   * 3 - Default event
   */
  sendWeightManagementPageView(): void {
    /*3*/
    this._gtmService.deprecatedSendPageView({
      type: 'Summary',
      module: 'Weight Management',
      moduleType: 'Consultation',
      virtualPageUrl: '/pet/weight-management',
    });
  }

  /**************
   * FOLLOW UP
   *************/

  /**
   * Weight Update
   */
  sendFollowUpWeightUpdatePageView(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Profile Update',
      module: 'Weight Management',
      moduleType: 'Consultation',
      virtualPageUrl: '/weight_management/weight_update',
    });
  }

  /**************
   * Renal Detect
   *************/

  /**
   * Renal detect make detection
   */
  sendRenalDetectValues(): void {
    this._gtmService.deprecatedSendPageView({
      type: 'Pet Profile',
      module: 'Renal Detect',
      moduleType: 'Consultation',
    });
  }
}
